import React from "react";
import Helper from "../../Helper";
import { ProcurementColors, ProcurementStrings } from "../../components/Materials/leadTimesHelper";
import DashboardProcurementChecklistItem from "./dashboardProcurementChecklistItem";

interface DashboardProcurementChecklistSectionProps {
    // Add props here as needed
    section: "requireOnSite" | "leadtime" | "submit" | "approve" | "order" | "checkin" | "receive" | "deliver";
    items: any[]; // Replace with the actual type of items
    sectionLabel?: string;
    project: any;
}

const DashboardProcurementChecklistSection: React.FC<DashboardProcurementChecklistSectionProps> = ({
    section,
    items,
    sectionLabel,
    project,
}) => {
    const procurementColors = ProcurementColors[section as keyof typeof ProcurementColors];
    const procurementStrings = ProcurementStrings[section as keyof typeof ProcurementStrings];
    return (
        <div className={`backdrop-blur-sm rounded-xl shadow-lg  ${procurementColors.bgColorCard}`}>
            <div className="px-6 py-2">
                <div className="flex items-center justify-between mb-4">
                    <div
                        className={Helper.classNames(
                            "text-xl font-semibold w-5/6 truncate",
                            procurementColors.textColor
                        )}
                    >
                        {sectionLabel || procurementStrings.dueLabel}
                    </div>
                    <div className="w-1/6"></div>
                </div>
                <div className="flex items-center justify-between text-white font-semibold">
                    <div className="w-1/6 text-center"></div>
                    <div className="w-4/6"></div>

                    <div className="w-1/6 text-center ">Due Date</div>
                </div>

                {items.map((item, index) => (
                    <DashboardProcurementChecklistItem
                        key={`${item.id}_${index}`}
                        item={item}
                        section={section}
                        project={project}
                    />
                ))}
            </div>
        </div>
    );
};

export default DashboardProcurementChecklistSection;
